import React from "react";

const Footer = () => {
  return (
    <div className='footer'>
      <p className='py-3'>We are currently in beta stage</p>
      <p>&copy;LearnCode 2020</p>
    </div>
  );
};

export default Footer;
